/* eslint-disable no-unused-vars */
/* eslint-disable indent */
import urls from "../../api/urls";
import NormalAPI from "../../api";

const {
  GET_HUBOPS_DATA,
  GET_SHIPMENT_BUSINESS_DATA,
  GET_DELIVERY_DATA,
  GET_ZONE_WISE_DATA,
} = urls;

export const DirectorDashboardService = {
  /**
   * Fetch HubOps data for Director Dashboard KPI cards
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing hub operations metrics
   */
  getHubOpsData: async (options = {}) => {
    try {
      const response = await NormalAPI.Api(GET_HUBOPS_DATA).post({});

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch HubOps data");
    } catch (error) {
      console.error("Error fetching HubOps data:", error);
      throw error;
    }
  },

  /**
   * Fetch Shipment Count and Business Data for Director Dashboard
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing business data and shipment counts
   */
  getShipmentBusinessData: async (options = {}) => {
    try {
      const response = await NormalAPI.Api(GET_SHIPMENT_BUSINESS_DATA).post({});

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Shipment Business Data");
    } catch (error) {
      console.error("Error fetching Shipment Business Data:", error);
      throw error;
    }
  },

  /**
   * Fetch Delivery Data for Director Dashboard
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing delivery metrics
   */
  getDeliveryData: async (options = {}) => {
    try {
      const response = await NormalAPI.Api(GET_DELIVERY_DATA).post({});

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Delivery Data");
    } catch (error) {
      console.error("Error fetching Delivery Data:", error);
      throw error;
    }
  },

  /**
   * Fetch Zone Wise Data for Director Dashboard
   * @param {string} fromDate - Start date in YYYY-MM-DD format
   * @param {string} toDate - End date in YYYY-MM-DD format
   * @param {Object} [options] - Additional options (e.g., signal for AbortController)
   * @returns {Promise<Object>} Response data containing zone-wise business, shipment, and delivery data
   */
  getZoneWiseData: async (fromDate, toDate, options = {}) => {
    try {
      const queryParams = {
        fromDate,
        toDate,
      };
      const queryString = new URLSearchParams(queryParams).toString();
      const url = `${GET_ZONE_WISE_DATA}?${queryString}`;

      const response = await NormalAPI.Api(url).getCustomHeader(options);

      if (response?.status && response?.response?.status === 200) {
        return {
          data: response?.response?.data || {},
          message: response?.response?.data?.status || "Success",
        };
      }
      throw new Error(response?.response?.data?.message || "Failed to fetch Zone Wise Data");
    } catch (error) {
      console.error("Error fetching Zone Wise Data:", error);
      throw error;
    }
  },
};

